import View0 from './View0'
import View1 from './View1'
import View2 from './View2'
import View3 from './View3'
import View6 from './View6'
import View7 from './View7'
import View8 from './View8'
import View4 from './View4'
import View5 from './View5'
import View9 from './View9'
import View10 from './View10'
import View11 from './View11'
import View12 from './View12'
import View13 from './View13'
import View14 from './View14'
import View15 from './View15'
import View16 from './View16'
import View17 from './View17'
import View18 from './View18'
import View19 from './View19'
import View20 from './View20'
import View21 from './View21'
import View22 from './View22'
import View23 from './View23'
import View24 from './View24'
import View25 from './View25'
import View26 from './View26'
import QuickReplies from './quick-replies'
import RelateReplies from './relate-replies'
import Question from './question'
import TopView from './topView'

export { View1,View2,View3,View6,Question,View0,TopView,View7,View8,View5,View9,View10,QuickReplies,RelateReplies,View4,View11,View12,View13,View14,View15,View16,View17,View18,View19,View20,View21,View22,View23,View24,View25,View26}
